import { useMutation, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { automationServices } from '@hero/services';
import { useNotification } from '@hero/store/hooks';

export const useStartAutomation = ({ options = {} } = {}) => {
  const queryClient = useQueryClient();
  const { showSuccess } = useNotification();

  return useMutation(({ code, body }) => automationServices.start(code, body), {
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries([QUERY_KEYS.useGetAutomationKey, variables.code]);
      queryClient.invalidateQueries('automations');

      showSuccess({
        message: 'Successfully started your automation.',
        type: 'toast'
      });
    },
    ...options
  });
};
